module.exports = __webpack_public_path__ + "static/media/template-csv.7332b0c9.csv";